<div class="jumbotron">
    <h1>{{ i18n._133_PULSE | translate }}</h1>
    <cmps-client-logo></cmps-client-logo>
</div>
<div
    class="container-fluid"
    [attr.aria-busy]="hasPendingData"
>
    <div
        class="row"
        *ngIf="!hasPendingData && groupConfig != null"
    >
        <div class="col-{{ groupConfig.width }}">
            <div class="row">
                <ng-template
                    ngFor
                    let-i
                    [ngForOf]="configs"
                >
                    <cmps-widget
                        class="col-{{ i.config?.width * 3 || 12 }} col-md-{{
                            i.config?.width * 1.5 || 6
                        }} col-lg-{{ i.config?.width || 4 }}"
                        [config]="i"
                    ></cmps-widget>
                </ng-template>
            </div>
        </div>
    </div>
</div>
